








import { listFactory } from '@/main/pages/listFactory';

import { store } from './store/list';
import { NAME } from './constants';

export default listFactory(NAME, store).extend({
	methods: {
		async filterClick() {
			this.$router.replace({ path: '/Oem/CorporateAccountRequestStatusForm/List', query: { dealerTenantCode: this.Dealers ?? '' } });
		},
	},
});
